import React from 'react';
import { Link } from "react-router-dom";

const Main = () => {

  return (
    <main className="main">
      <div className="page-title dark-background">
        <div className="heading">
          <div className="container">
            <div className="row d-flex justify-content-center text-center">
              <div className="col-lg-8">
                <h1>Informasi</h1>
              </div>
            </div>
          </div>
        </div>
        <nav className="breadcrumbs">
          <div className="container">
            <ol>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/jadwal-dokter">Jadwal Dokter</Link></li>
              <li><Link to="/pendaftaran-online">Pendaftaran Online</Link></li>
              <li><Link to="/telemedic">Telemedic</Link></li>
              <li className="current">Informasi</li>
              <li><Link to="/pengaduan">Pengaduan</Link></li>
            </ol>
          </div>
        </nav>
      </div>

      <section id="service-details" className="service-details section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="services-list">
                <Link to="/bed">Ketersediaan Tempat Tidur</Link>
                <Link to="/jadwal-dokter">Jadwal Dokter</Link>
                <Link to="/pendaftaran-online">Pendaftaran Online</Link>
                <Link to="/telemedic">Telemedic</Link>
                <Link className="active" to="/informasi">Informasi</Link>
                <Link to="/pengaduan">Pengaduan</Link>
              </div>

              

      <div className="card">
        <div className="card-header text-center bg-secondary text-white">
          <a href="https://drive.google.com/file/d/1dlwr-6pftr8hsa7T7UahA7O-Dt9FVMq4/view?usp=sharing" className="text-white text-decoration-none">
            MAKLUMAT PELAYANAN
          </a>
        </div>
        <div className="card-header">
          <ul className="list-group list-group-flush">
            <li className="list-group-item">
              SK Jenis-jenis Pelayanan Kesehatan dan Penunjang Pelayanan Kesehatan 
              <a href="https://drive.google.com/file/d/1xC9SS8mY0VhOiJIeNv_qMKfEc01zzR1H/view?usp=sharing" className="btn btn-link">Download</a>
            </li>
            <li className="list-group-item">
              SK Standar Pelayanan 
              <a href="https://drive.google.com/file/d/1K4K-HQqSysPJ3clhTWfxbGDvGS6dGfL0/view?usp=sharing" className="btn btn-link">Download</a>
            </li>
            <li className="list-group-item">
              Survei Kepuasan Masyarakat (SKM) RSUD H. Abdul Manap Kota Jambi Semester I Tahun 2022 
              <a href="https://drive.google.com/file/d/13PcnJlMNN8q1bj1Af57KWUCHcFfx5Rdn/view?usp=sharing" className="btn btn-link">Download</a>
            </li>
            <li className="list-group-item">
              Survei Kepuasan Masyarakat (SKM) RSUD H. Abdul Manap Kota Jambi Semester I Tahun 2023 
              <a href="https://drive.google.com/file/d/1BZLFo_eoArl4KgKTLmwTkAr2waM1z-iq/view?usp=sharing" className="btn btn-link">Download</a>
            </li>
            <li className="list-group-item">
              Data Indikator Mutu 2023 
              <a href="https://drive.google.com/file/d/1Q_a6fBcvTWBgWz2LKw_JkaGewfljrtD9/view?usp=sharing" className="btn btn-link">Download</a>
            </li>
          </ul>
        </div>
      </div>
            </div>
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">

<div className="row mb-3">
                <div className="col">

      <div className="card">
        <div className="card-header text-center bg-secondary text-white">
            PANDUAN PENGGUNAAN SIMANAP
        </div>
        <div className="card-header">
          <ul className="list-group list-group-flush">
            <li className="list-group-item">
              Panduan pengaksesan simanap.com dan penggunaan fitur-fitur pada Simanap.
              <a href="https://drive.google.com/file/d/1ZMEM0TJ4QCG51mcp881Dwb4EoCkL9jFg/view?usp=sharing" className="btn btn-link">Download</a>
            </li>
          </ul>
        </div>
      </div>
      </div>
          </div>
              <div className="row">
                <div className="col">
                   <div className="col">
  <div className="card">
  <div className="card-header text-center bg-secondary text-white">
    PENERIMAAN TENAGA KERJA KONTRAK TAHUN 2023
  </div>
  <div className="card">
      <div className="card-header">
       <h6 className="card-title">Nomor: Peg. 13.00/3651/Dinkes/2023</h6>
        <p className="card-text">
          Dalam rangka Penerimaan Tenaga Kerja Kontrak di Lingkungan RSUD H. Abdul Manap Kota Jambi Tahun 2023, setelah melakukan seleksi Psikotes terhadap peserta, maka bersama ini diumumkan kepada peserta yang lulus Psikotes (Daftar nama-nama terlampir). Selanjutnya kepada nama-nama peserta yang dinyatakan lulus untuk dapat mengikuti tes tahapan berikutnya berupa tes wawancara.
        </p>
        <a href="https://drive.google.com/file/d/1z-YmV6FkmDW5VFKDMgNSkqEpk5dSoHCX/view?usp=sharing" className="btn btn-link">Download</a>
      </div>
      <div className="card-header">
        <h6 className="card-title">Nomor: Peg.13.01/3334/Dinkes/2023</h6>
        <p className="card-text">
          Dalam rangka Penerimaan Tenaga Kerja Kontrak di Lingkungan RSUD H. Abdul Manap Kota Jambi Tahun 2023, setelah melakukan seleksi Uji Tulis terhadap peserta, maka bersama ini diumumkan kepada peserta yang lulus seleksi Uji Tulis (Daftar nama-nama terlampir). Selanjutnya kepada nama-nama yang dinyatakan lulus untuk dapat mengikuti tahapan berikutnya berupa psikotes.
        </p>
        <a href="https://drive.google.com/file/d/1z-YmV6FkmDW5VFKDMgNSkqEpk5dSoHCX/view?usp=sharing" className="btn btn-link">Download</a>
      </div>
      <div className="card-header">
        <h6 className="card-title">Nomor : Peg.01.00/3039/Dinkes/2023</h6>
        <p className="card-text">
          Dalam rangka Penerimaan Tenaga Kerja Kontrak Dilingkungan RSUD H. Abdul Manap Kota Jambi Tahun 2023, setelah melakukan seleksi Administrasi terhadap lamaran peserta, maka bersama ini diumumkan kepada peserta yang lulus seleksi administrasi (Daftar nama-nama terlampir). Selanjutnya kepada Nama-nama yang dinyatakan Lulus untuk dapat mengikuti tahapan berikutnya berupa Uji Tulis.
        </p>
        <a href="https://drive.google.com/file/d/1OuGbQe7NbF82rDTIXCKTe1FPUgzjyNOu/view?usp=sharing" className="btn btn-link">Download</a>
      </div>
      <div className="card-header">
        <h6 className="card-title">Nomor: Peg. 02/4342/Dinkes/2023</h6>
        <p className="card-text">
          Dalam rangka Penerimaan Tenaga Kerja Kontrak di Lingkungan RSUD H. Abdul Manap Kota Jambi Tahun 2O23, setelah melakukan seleksi interview terhadap peserta, maka bersama ini diumumkan kepada peserta yang lulus Seleksi (Daftar Nama-nama terlampir).
        </p>
        <a href="https://drive.google.com/file/d/1se3K-Vj8jSCqpQjThtUpoirY4fUj6XuR/view?usp=sharing" className="btn btn-link">Download</a>
      </div>

  </div>
</div>
                </div>
                </div>
              </div>




    


            </div>

          </div>
        </div>

      </section>
    </main>
  );
};

export default Main;
